import { Skeleton } from 'antd';

const TextOrLoading = ({ text, ...skProps }) => {
  return (
    <>
      {text ? text : <Skeleton loading active paragraph={false} {...skProps} />}
    </>
  );
};

export default TextOrLoading;
